import React from 'react';
import Select from 'react-select';

const SelectItem = ({options, value, placeholder, onChange, multi}) => {
	return (
		<>
			<Select options={options} isSearchable={false} isMulti={multi} value={value} closeMenuOnSelect={multi ? false : true} onChange={onChange} placeholder={placeholder} />
		</>
	);
}

export default SelectItem;
